import { useModal } from "common/hooks";
import ActionLink from "components/ActionLink";
import RequestFarmAccessModal from "./RequestFarmAccessModal";

export default function RequestFarmAccessActionLink({ farm, children = "Request access", className = "IconLink--arrow-plus" }) {
    const [requestFarmAccessModal, openRequestFarmAccessModal] = useRequestFarmAccessModal(farm);
    return (<>
        <ActionLink id={`request-farm-access-${farm.id}`} className={className} onClick={openRequestFarmAccessModal}>
            {children}
        </ActionLink>
        {requestFarmAccessModal}
    </>);
}

const useRequestFarmAccessModal = (farm) => {
    const [modal, openModal] = useModal(RequestFarmAccessModal);

    const openRequestFarmAccessModal = () => {
        const modalProps = {
            accessRequest: {
                farmId: farm.id,
                farmName: farm.name,
                address: farm.address,
                ownershipStatus: farm.ownershipStatus,
                currentRole: farm.role,
            }
        };
        openModal(modalProps);
    };

    return [modal, openRequestFarmAccessModal];
}
